import { render, staticRenderFns } from "./RecognitionDialog.vue?vue&type=template&id=dd240c80"
import script from "./RecognitionDialog.vue?vue&type=script&lang=js"
export * from "./RecognitionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports